/**
 * Contains value of `VITE_APP_BASE_URL` from `.env.*` files or
 * `window.location.origin` + `/api` if `VITE_APP_BASE_URL` is not defined.
 * Second case is used for deployment to dev or prod environment together with proxy pass config in `nginx.conf`.
 */
export const BASE_REST_API_URL = `${import.meta.env.VITE_APP_BASE_URL ?? window.location.origin}/api`;
